import styled from 'styled-components'

const ContentTableHeaderIconWrapperUi = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`

export default ContentTableHeaderIconWrapperUi
